import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { UserGroup } from '../auth/models/user.model';
import { AuthService } from '../auth/services/auth.service';
import { RoutePath } from '../enums/route-path.enum';

export function authGroupGuard(requiredGroups?: UserGroup[]): CanActivateFn {
  return async () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    try {
      await firstValueFrom(auth.initSession());

      if (requiredGroups?.length && !auth.hasAnyGroup(requiredGroups)) {
        await router.navigate([RoutePath.NoAccess]);
        return false;
      }

      return true;
    } catch {
      return router.createUrlTree([RoutePath.Login]);
    }
  };
}
